import { render, staticRenderFns } from "./u-header-head-basic.vue?vue&type=template&id=07b3b083&scoped=true&"
import script from "./u-header-head-basic.vue?vue&type=script&lang=js&"
export * from "./u-header-head-basic.vue?vue&type=script&lang=js&"
import style0 from "./u-header-head-basic.vue?vue&type=style&index=0&id=07b3b083&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b3b083",
  null
  
)

export default component.exports